// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"348":"cef564d6","423":"022906d4","453":"cc0ab23b","474":"c5613b8c","817":"9c71ba3e","924":"58d59593"}[chunkId] + ".chunk.js";
};